import { useState, useEffect } from "react";
import { Card, CardContent } from "@/components/ui/card";
import axios from "axios";
import { API, useAuth } from "@/App";

export default function AdminSubscribers() {
  const [subscribers, setSubscribers] = useState([]);
  const [loading, setLoading] = useState(true);
  const { getToken } = useAuth();

  useEffect(() => {
    const fetchSubscribers = async () => {
      try {
        const res = await axios.get(`${API}/admin/subscribers`, {
          headers: { Authorization: `Bearer ${getToken()}` },
        });
        setSubscribers(res.data);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    fetchSubscribers();
  }, [getToken]);

  return (
    <div className="space-y-4" data-testid="admin-subscribers">
      <h1 className="font-heading text-2xl font-bold text-gray-900">Newsletter Subscribers ({subscribers.length})</h1>

      {loading ? (
        <div className="space-y-3">{[...Array(3)].map((_, i) => <div key={i} className="h-12 bg-gray-200 animate-pulse rounded-lg" />)}</div>
      ) : subscribers.length === 0 ? (
        <Card className="border-gray-200"><CardContent className="p-8 text-center text-gray-400">No subscribers yet.</CardContent></Card>
      ) : (
        <Card className="border-gray-200">
          <CardContent className="p-0">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead className="bg-gray-50">
                  <tr className="text-left">
                    <th className="px-4 py-3 font-medium text-gray-500">#</th>
                    <th className="px-4 py-3 font-medium text-gray-500">Email</th>
                    <th className="px-4 py-3 font-medium text-gray-500">Status</th>
                    <th className="px-4 py-3 font-medium text-gray-500">Subscribed</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {subscribers.map((s, i) => (
                    <tr key={s.id} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-gray-400">{i + 1}</td>
                      <td className="px-4 py-3 font-medium text-gray-800">{s.email}</td>
                      <td className="px-4 py-3">
                        <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${s.active ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-500"}`}>
                          {s.active ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-gray-500 text-xs">{new Date(s.subscribed_at).toLocaleDateString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
